import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, Box, Modal, Switch, Typography, Collapse } from "@mui/material";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tab from '@mui/material/Tab';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import { DataGrid, GridActionsCellItem, GridRowParams, GridToolbar } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
// import useApiPrivate from '../auth/useApiPrivate';
import CancelIcon from '@mui/icons-material/Cancel';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CircularProgress from '@mui/material/CircularProgress';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { FormatedDate } from '../components/SavingsDetails';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
  }

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };


const MainAccounts = ({ setMessage, setOpe, society_id, name }) => {
    const [account_details, setAccount_details] = useState([]);
    const [account_details_cash, setAccount_details_cash] = useState([]);
    const [account_transactions, setAccount_transactions] = useState([]);
    const [transactions_data, setTransactions_data] = useState([]);
    const [open, setOpen] = useState(false)
    const [momo_open, setMomo_open] = useState(false)
    const [bank_accounts, setBank_accounts] = useState([]);
    const [momo_deposits, setMomo_deposits] = useState([]);
    const navigate = useNavigate()
    const [what, setWhat] = useState(false);
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    const [society_name, setSociety_name] = useState('Society')
    const [value1, setValue1] = useState(0);
    const [value2, setValue2] = useState(0);
    const [society_data, setSociety_data] = useState([])
    const [investor_deposits, setInvestor_deposits] = useState([])
    const [main_ware_data, setMain_ware_data] = useState([])
    const [start_date1, setStart_date1] = useState('')
    const [end_date1, setEnd_date1] = useState('')
    const [expandedTransactions, setExpandedTransactions] = useState({});

    const toggleTransaction = (transactionId) => {
        setExpandedTransactions(prev => ({
          ...prev,
          [transactionId]: !prev[transactionId]
        }));
      };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-GH', {
          style: 'currency',
          currency: 'GHS',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const filter_data = () => {
        const data = new FormData()
        data.append('society_id', society_id)
        data.append('start_date', start_date1)
        data.append('end_date', end_date1)
        

        api.post('/association/society/momo/transactions', data, {
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setAccount_transactions(response.data?.transactions);
        }).catch(function (error){
            console.log(error)
        })
    }

    const handleDateFilter = () => {
        if (start_date1 && end_date1 && new Date(start_date1) > new Date(end_date1)) {
          toast.error('Start date cannot be after end date');
          return;
        }
        filter_data();
    };

    function formatDateToYearMonthDay(date) {
        const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = "th";

        if (day === 1 || day === 21 || day === 31) {
        suffix = "st";
        } else if (day === 2 || day === 22) {
        suffix = "nd";
        } else if (day === 3 || day === 23) {
        suffix = "rd";
        }

        return `${day}${suffix} ${month} ${year}`;
    }
    
    const handleChange1 = (event, newValue) => {
        setValue1(newValue);
    };

    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
    };
    

    const fetch_account_details = () => {
        // account details
        api.get(`/association/society/momo/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setAccount_details(response.data?.data);
        }).catch(function (error){
            console.log(error)
        })

        // invested funds
        api.get(`/investors/society/investments/${society_id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
          setSociety_data(response?.data);
        }).catch(function (error){
            console.log(error)
        })

        // invested funds bank/momo
        api.get(`/investors/transaction/investor/account/ecash/data/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function (response) {
            // console.log(response.data);
            setInvestor_deposits(response.data);
          }).catch(function (error){
            console.log(error)
          })

        // society warehouse transactions
        api.get(`/societywarehouse/release/data/main/account/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function (response) {
            setMain_ware_data(response.data?.trs);
          }).catch(function (error){
            console.log(error)
          })
        
        // society name
        api.get(`/investors/society/get/name/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response) {
            setSociety_name(response.data);
        }).catch(function (error){
            console.log(error)
        })

        // account transactions
        const data = new FormData()
        data.append('society_id', society_id)
        data.append('start_date', start_date1)
        data.append('end_date', end_date1)
        

        api.post('/association/society/momo/transactions', data, {
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setAccount_transactions(response.data?.transactions);
        }).catch(function (error){
            console.log(error)
        })

        // account details cash
        const sendData = new FormData()
        sendData.append('society_id', society_id)
        sendData.append('start_date', start_date)
        sendData.append('end_date', end_date)
        api.post('/association/cash/society/data', sendData,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setAccount_details_cash(response.data);
            setTransactions_data(response.data?.transactions)
        }).catch(function (error){
            console.log(error)
        })

        // bank accounts
        api.get(`/account/society/all/${society_id}`,{
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            setBank_accounts(response.data?.Accounts);
        }).catch(function (error){
            console.log(error)
        })

        // momo transactions
        api.get(`/association/society/mo/deposits/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setMomo_deposits(response.data?.data);
        }).catch(function (error){
            console.log(error)
        })
    }


    const cancelFilter = () =>{
        setStart_date('');
        setEnd_date('');
        fetch_account_details();
    }

    useState(()=>{
        fetch_account_details()
    },[])


    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 720,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        bgcolor: 'background.paper',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
    };

    const momo_style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
            height: '7px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
    };


    const handleModalClose = () => {
        setOpen(false)
    }

    const visitAssociation = (id) => {
        api.get(`/association/${id}`,{
          headers :{
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            navigate('/association/', { state: { responseData: response.data } })
        }).catch(function (error){
          console.log(error)
        });
    }

    function formatDateToYearMonthDay(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = 'th';
      
        if (day === 1 || day === 21 || day === 31) {
          suffix = 'st';
        } else if (day === 2 || day === 22) {
          suffix = 'nd';
        } else if (day === 3 || day === 23) {
          suffix = 'rd';
        }
      
        return `${day}${suffix} ${month} ${year}`;
      }

      function formatDateToYearMonthDayTime(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = 'th';
      
        if (day === 1 || day === 21 || day === 31) {
          suffix = 'st';
        } else if (day === 2 || day === 22) {
          suffix = 'nd';
        } else if (day === 3 || day === 23) {
          suffix = 'rd';
        }
      
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    
        return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
      }

    const columns_cash_trs = [
        {
            field: "id",
            headerName: 'Id',
            flex: 1
        },
        {
            field: "association_id",
            headerName: 'Savings Group Id',
            flex: 1
        },
        {
            field: "date",
            headerName: 'Date',
            flex: 1,
            renderCell:(params) => formatDateToYearMonthDay(new Date(params.row.date))
        },
        {
            field: "debit",
            headerName: 'Debit',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.debit)}</b></Typography>,
        },
        {
            field: "credit",
            headerName: "Credit",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.credit)}</b></Typography>,
        },
        {
            field: "cash_value",
            headerName: "Cash Value (Credit - Debit)",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.cash_value)}</b></Typography>,
        },
        {
            field: "association",
            headerName: 'Savings Group',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.association}</b></Typography>,
            
        },
        {
            field: 'open',
            type: 'actions',
            flex:1,
            getActions: (params: GridRowParams) => [
                <GridActionsCellItem
                    icon={<OpenInNewIcon />}
                    onClick={() => visitAssociation(params.row.association_id)} 
                    label="Open"
                />,
            ]
        },
    ]


    const columns_investment_banks = [
        {
            field: "id",
            headerName: 'Id',
            flex: 1
        },
        {
            field: "date",
            headerName: 'Date',
            flex: 1,
            renderCell:(params) => formatDateToYearMonthDay(new Date(params.row.date))
        },
        {
            field: "investor_name",
            headerName: 'Investor',
            flex: 1
        },
        {
            field: "via",
            headerName: 'Payment Method',
            flex: 1,
        },
        {
            field: "amount_done",
            headerName: "Amount",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.amount_done)}</b></Typography>,
        },
        {
            field: "bank_name",
            headerName: "Bank (if via bank)",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.bank_name}</b></Typography>,
        },
        {
            field: "momo_number",
            headerName: 'Momo number (if via momo number)',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.momo_number}</b></Typography>,
            
        },
    ]

    const columns_inves = [
        {
            field: "investment_id",
            headerName: 'Id',
            flex: 1
        },
        {
            field: "date",
            headerName: 'Date',
            flex: 1,
            renderCell:(params) => formatDateToYearMonthDay(new Date(params.row.date))
        },
        {
            field: "investor_name",
            headerName: 'Investor name',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.investor_name}</b></Typography>,
        },
        {
            field: "amount_investing",
            headerName: "Amount Invested",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.amount_investing)}</b></Typography>,
        },
        {
            field: "description",
            headerName: "Investment Type",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.description}</b></Typography>,
        },
        {
            field: "expected_income",
            headerName: 'Investment returns',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.expected_income)}</b></Typography>,
            
        },
    ]

    const columns_ware = [
        {
            field: "transaction_id",
            headerName: 'Id',
            flex: 1
        },
        {
            field: "date",
            headerName: 'Date',
            flex: 1,
            renderCell:(params) => formatDateToYearMonthDayTime(new Date(params.row.date))
        },
        {
            field: "amount",
            headerName: "Amount Released",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.amount)}</b></Typography>,
        },
        {
            field: "narration",
            headerName: "Narration",
            flex:1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.narration}</b></Typography>,
        },
        {
            field: "balance",
            headerName: 'Account Balance',
            flex: 1,
            renderCell:(params) =>  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.balance)}</b></Typography>,
            
        },
    ]
    
    
    
    const columns_cash = [
        {
            field: "Association_id",
            headerName: 'Savings Group id',
            flex: 1,
        },
        {
            field: "Association",
            headerName: 'Savings Group',
            flex: 1,
        },
        {
            field: "number_of_accounts",
            headerName: "Accounts opened",
            flex:1,
        },
        {
            field: "total_savings",
            headerName: "Total deposits",
            flex:1,
            renderCell:(params) =>  currencyFormat.format(params.row.total_savings),
        },
        {
            field: 'open',
            type: 'actions',
            flex:1,
            getActions: (params: GridRowParams) => [
                <GridActionsCellItem
                    icon={<OpenInNewIcon />}
                    onClick={() => visitAssociation(params.row.Association_id)} 
                    label="Open"
                />,
            ]
        },
    ]

    const columns = [
        {
            field: "transaction_date",
            headerName: 'DateTime',
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell:(params) => formatDateToYearMonthDay(new Date(params.row.date))
        },
        {
            field: "narration",
            headerName: "Narration",
            flex:1,
            width: 70,
            editable:true
        },
        {
            field: "debit",
            headerName: "Debit",
            flex:1,
            width: 70,
            renderCell:(params) =>  params.row.type === "withdrawal" ?currencyFormat.format(params.row.amount):currencyFormat.format(0),
        },
        {
            field: "credit",
            headerName: "Credit",
            flex:1,
            width: 70,
            renderCell:(params) =>  params.row.type === "deposit" ?currencyFormat.format(params.row.amount):currencyFormat.format(0),
        },
        {
            field: "balance",
            headerName: "Account Balance",
            flex:1,
            width: 70,
            renderCell:(params) => currencyFormat.format(params.row.balance)
        },
        {
            field: "transaction_id",
            headerName: "Id",
            flex:1,
            width: 70,
        },
        {
            field: "account_name",
            headerName: "Account Name(Bank)",
            flex:1,
            width: 70,
            editable:true
        },
        {
            field: "username",
            headerName: "Prepared by",
            flex:1,
            width: 70,
        },
    ]

    const momo_columns = [
        {
            field: "date",
            headerName: 'DateTime',
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell:(params) => <FormatedDate value={params.row.date}/>
        },
        {
            field: "momo_bal",
            headerName: "Amount",
            flex:1,
            renderCell:(params) =>  currencyFormat.format(params.row.momo_bal),
        },
        {
            field: "association_name",
            headerName: "Savings Group",
            flex:1,
        },
        {
            field: "association_type",
            headerName: "Savings Group Type",
            flex:1,
        },
        {
            field: "association_id",
            headerName: "Savings Group Id",
            flex:1,
        },
        {
            field: 'open',
            type: 'actions',
            flex:1,
            getActions: (params: GridRowParams) => [
            <GridActionsCellItem
            icon={<OpenInNewIcon />}
            onClick={() => handleClickOpen(params.row.association_id, params.row.association_type, params.row.association_name)} 
            label="Open"
            />,]
        },
    ]



    const formik = useFormik({
    initialValues: {
        to_account_id: null,
        amount: null,
        narration: ''
    },
    validationSchema: Yup.object({
        amount: Yup.number()
        .required('Specify amount to transfer').min(0).max(account_details.current_balance),
        narration: Yup.string('Must be characters')
    }),
    onSubmit: (values) => {
        const data = new FormData()
        data.append('bank_id', values.to_account_id)
        data.append('amount', values.amount)
        data.append('narration', values.narration)
        data.append('ecash_id', account_details.id)

        api.post('/association/society/momo/transactions/transfer', data , {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            setMessage(response.data)
            setOpe(true)
            formik.handleReset()
            handleModalClose()
            fetch_account_details()
        }).catch(function (error){
            console.log(error)
        })
    }
    })

    const handleClickOpen = (id, typpe, name) => {
        const somm = {
          association_id: id,
          typee: "savings",
          date: new Date()
        }
          api.post('/association/cash/settings',somm,{
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
          }).then(function (response){
              navigate('/accounts/momo', {
                state:
                {
                  association_id: id,
                  association_name: `${name} ${typpe}`,
                }
              })
          }).catch(function (error){
            console.log(error)
          });
      };


    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <Box sx={{ display:'inline-flex' }}>
                    <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Main Wallet Account</b> 
                    <Switch
                        checked={what}
                        onChange={(event) => setWhat(event.target.checked)}
                        sx={{color:'#001845'}}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                    <b>Cash Data</b>
                    </Typography>
                </Box>
            </Grid>

            {
                !what?
                <>
                    <Grid item xs={12} md={12}>
                    <Typography variant='h4' sx={{ textAlign:'center', mb:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Main Wallet Account</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Typography variant='h6' sx={{ textAlign:'center', mb:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Current Balance: {currencyFormat.format(account_details?.current_balance)} </b>
                        <IconButton onClick={() => setMomo_open(true)}><OpenInNewIcon /></IconButton>
                    </Typography>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Button 
                        variant='contained'  
                        sx={{ alignItems:'center',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                            minWidth: 0,
                            '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                            backgroundColor:'#80ed99',
                            color:'#000'
                            }, 
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Transfer
                    </Button>
                </Grid>

                <Grid item xs={12} md={12} sx={{ marginBottom:15, width:100 }}>
                <Box sx={{ 
      overflowX: 'auto',
      maxHeight: '80vh',
      overflowY: 'auto',
      "&::-webkit-scrollbar": {
        width: "7px",
        height: "7px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }}>
      {/* Date Filter */}
      <Box display="flex" alignItems="center" mb={2}>
        <TextField
          type="date"
          size="small"
          label="From"
          InputLabelProps={{ shrink: true }}
          value={start_date1}
          onChange={(e) => setStart_date1(e.target.value)}
          sx={{ mr: 2, width: 180 }}
        />
        <TextField
          type="date"
          size="small"
          label="To"
          InputLabelProps={{ shrink: true }}
          value={end_date1}
          onChange={(e) => setEnd_date1(e.target.value)}
          sx={{ mr: 2, width: 180 }}
        />
        <Button
          variant="contained"
          onClick={handleDateFilter}
        >
          Filter
        </Button>
      </Box>

      
        <Table size="small" aria-label="ecash transactions table">
          <TableHead>
            <TableRow sx={{ position: 'sticky', top: 0, backgroundColor: 'background.paper', zIndex: 1 }}>
              <TableCell>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Date</b>
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Debit</b>
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Credit</b>
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Balance</b>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Details</b>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Source</b>
                </Typography>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {account_transactions.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    No transactions found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
                account_transactions.slice().reverse().map((transaction) => (
                <React.Fragment key={transaction.transaction_id}>
                  <TableRow sx={{ backgroundColor: expandedTransactions[transaction.transaction_id] ? '#f0f7ff' : 'inherit' }}>
                    <TableCell>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{formatDate(transaction.date)}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography 
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        color='error.main'
                      >
                        <b>{transaction.type === 'withdrawal' ? formatCurrency(transaction.amount) : formatCurrency(0)}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography 
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        color='success.main'
                      >
                        <b>{transaction.type === 'deposit' ? formatCurrency(transaction.amount) : formatCurrency(0)}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{formatCurrency(transaction.balance)}</b>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{transaction.narration}</b>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{transaction.source === 'investment' ? 'Investment' : 
                         transaction.source === 'mobile_money' ? 'Mobile Money' : 
                         transaction.source === 'expenditure' ? 'Expenditure' : 
                         transaction.source === 'loans' ? 'Loan Disbursement' : 
                         'Bank Transfer'}</b>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <IconButton size="small" onClick={() => toggleTransaction(transaction.transaction_id)}>
                        <b>{expandedTransactions[transaction.transaction_id] ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}</b>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  
                  <TableRow>
                    <TableCell colSpan={7} style={{ padding: 0 }}>
                      <Collapse in={expandedTransactions[transaction.transaction_id]} timeout="auto" unmountOnExit>
                        <Box sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Transaction Details</b>
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Date:</b> {formatDate(transaction.date)}
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Type:</b> {transaction.type === 'deposit' ? 'Deposit' : 'Withdrawal'}
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Amount:</b> {formatCurrency(transaction.amount)}
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Balance:</b> {formatCurrency(transaction.balance)}
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Source: {transaction.source === 'investment' ? 'Investment' : 
                                               transaction.source === 'mobile_money' ? 'Mobile Money' : 
                                               'Bank Transfer'}</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Description</b>
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{transaction.narration}</b>
                              </Typography>
                              {transaction.account_name && (
                                <>
                                  <Typography variant="subtitle2" mt={2} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{transaction.type === 'deposit' ? 'From' : 'To'}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{transaction.account_name}</b>
                                  </Typography>
                                </>
                              )}
                              {transaction.prep_by && (
                                <>
                                  <Typography variant="subtitle2" mt={2} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Processed By</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{transaction.prep_by}</b>
                                  </Typography>
                                </>
                              )}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
    </Box>
                    {/* <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Filter Date</Typography>
                    <div style={{ display:'flex' }}>
                        <TextField
                            type='date'
                            size="small"
                            required
                            variant="outlined"
                            helperText="From"
                            name="start_date1"
                            onChange={(e) => setStart_date1(e.target.value)}
                            value={start_date1}
                            sx={{ mr:1 }}
                        />

                        <TextField
                            type='date'
                            size="small"
                            required
                            variant="outlined"
                            helperText="To"
                            name="end_date1"
                            onChange={(e) => setEnd_date1(e.target.value)}
                            value={end_date1}
                            sx={{ mr:1 }}
                        />
                    </div>
                    <DataGrid
                        rows={account_transactions}
                        columns={columns}
                        checkboxSelection
                        getRowId={(row) => row.transaction_id}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: { 
                                    transaction_id: false,
                                },
                            },
                        }}
                    /> */}

                </Grid>
                </>
                :
                    <>
                        <Grid item xs={12} md={12}>
                            <Typography variant='h4' sx={{ textAlign:'center', mb:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Cash Deposits</b>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography variant='h6' sx={{ textAlign:'center', mb:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total current balance:  {currencyFormat.format(account_details_cash?.balance)}</b>
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Tabs
                                variant="fullWidth"
                                value={value1}
                                onChange={handleChange1}
                                aria-label="basic tabs example"
                                sx={{ 
                                    backgroundColor:'#e9ecef', 
                                    borderRadius:7, 
                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor:'#f8f9fa',
                                    },
                                }}
                            >
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Savings Groups cash flow</b>} {...a11yProps(0)} />
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Savings Groups cash summaries</b>} {...a11yProps(1)} />
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Investors cash flow</b>} {...a11yProps(1)} />
                            </Tabs>
                        </Grid>

                        <Grid item xs={12} md={12}>
                        <CustomTabPanel value={value1} index={0}>
                            <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ marginBottom:'10px', textAlign:'center' }}>
                                <b>
                                    Current cash flow
                                </b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Filter Date</Typography>
                            <div style={{ display:'flex' }}>
                                <TextField
                                    type='date'
                                    size="small"
                                    required
                                    variant="outlined"
                                    helperText="From"
                                    name="start_date"
                                    onChange={(e) => setStart_date(e.target.value)}
                                    value={start_date}
                                    sx={{ mr:1 }}
                                />

                                <TextField
                                    type='date'
                                    size="small"
                                    required
                                    variant="outlined"
                                    helperText="To"
                                    name="end_date"
                                    onChange={(e) => setEnd_date(e.target.value)}
                                    value={end_date}
                                    sx={{ mr:1 }}
                                />

                                <IconButton onClick={fetch_account_details}><FilterAltOutlinedIcon /></IconButton>
                                <IconButton onClick={cancelFilter}><CancelIcon /></IconButton>
                                
                            </div>
                            <DataGrid
                                rows={transactions_data}
                                columns={columns_cash_trs}
                                checkboxSelection
                                getRowId={(row) => row.id}
                                slots={{ toolbar: GridToolbar }}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: { 
                                            association_id: false,
                                            id: false,
                                        },
                                    },
                                }}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value1} index={1}>
                            <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ marginBottom:'10px', textAlign:'center' }}>
                                <b>
                                    Summarized cash flow
                                </b>
                            </Typography>
                            <DataGrid
                                rows={account_details_cash?.data}
                                columns={columns_cash}
                                checkboxSelection
                                getRowId={(row) => row.Association_id}
                                slots={{ toolbar: GridToolbar }}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: { 
                                            Association_id: false,
                                        },
                                    },
                                }}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value1} index={2}>
                            <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', marginRight:'auto' }}>
                                <b>Invested funds</b>
                            </Typography>
                            <DataGrid
                                rows={society_data?.all_investments}
                                columns={columns_inves}
                                checkboxSelection
                                getRowId={(row) => row.investment_id}
                                slots={{ toolbar: GridToolbar }}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: { 
                                            investment_id: false
                                        },
                                    },
                                }}
                            />
                        </CustomTabPanel>
                        
                        </Grid>
                        
                    </>
            }
            

        {/* Modals */}
            <Modal
              open={open}
              onClose={handleModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Grid container>
                    <Grid item xs={12} md={12}>
                        <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}>
                            <b>Transfer to Other Account</b>
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={bank_accounts}
                            sx={{ width: 300 }}
                            getOptionLabel={(option) => `${option.account_name}`}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, value) => {
                                if (value) {
                                    formik.setFieldValue('to_account_id', value.id);
                                }
                            }}
                            renderInput={(params) => <TextField {...params} size='small' label="Select Other Account" />}
                        />

                        <TextField
                            margin="dense"
                            size='small'
                            name="narration"
                            label="Narration (optional)"
                            onChange={formik.handleChange}
                            type="text"
                            value={formik.values.narration}
                            onBlur={formik.handleBlur}
                            error={formik.touched.narration && Boolean(formik.errors.narration)}
                            helperText={formik.touched.narration && formik.errors.narration}
                            fullWidth
                            variant="outlined"
                        />

                        <TextField
                            margin="dense"
                            size='small'
                            name="amount"
                            label="Amount (GHS)"
                            onChange={formik.handleChange}
                            value={formik.values.amount}
                            onBlur={formik.handleBlur}
                            error={formik.touched.amount && Boolean(formik.errors.amount)}
                            helperText={formik.touched.amount && formik.errors.amount}
                            type="number"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Box sx={{ display:'flex' }}>
                            <Button
                                variant='contained'
                                size='small'
                                color='error'
                                onClick={handleModalClose}
                                sx={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#80ed99',
                                        color:'#000'
                                    }, 
                                }}
                            >
                                Close
                            </Button>

                            <Button
                                onClick={formik.handleSubmit}
                                variant='contained'
                                color='success'
                                size='small'
                                disabled={formik.values.amount === null && formik.values.to_account_id === null}
                                sx={{ ml:'10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#80ed99',
                                        color:'#000'
                                    }, 
                                }}
                            >
                                Transfer
                            </Button>
                        </Box>
                    </Grid>
                </Grid>   
              </Box>
            </Modal>

            <Modal
              open={momo_open}
              onClose={() => setMomo_open(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={momo_style}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Tabs
                                variant="fullWidth"
                                value={value2}
                                onChange={handleChange2}
                                aria-label="basic tabs example"
                                sx={{ 
                                    backgroundColor:'#e9ecef', 
                                    borderRadius:7, 
                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor:'#f8f9fa',
                                    },
                                }}
                            >
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Savings Groups Ecash flow</b>} {...a11yProps(0)} />
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Investors Bank/Momo records</b>} {...a11yProps(1)} />
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Society Warehouse records</b>} {...a11yProps(1)} />
                            </Tabs>
                        </Grid>
                        <Grid item xs={12} md={12} sx={{ mb:1 }}>
                            <CustomTabPanel value={value2} index={0}>
                                <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', marginRight:'auto' }}>
                                    <b>Momo Accounts Deposits</b>
                                </Typography>
                                <Button
                                    variant='contained'
                                    size='small'
                                    color='error'
                                    onClick={() => setMomo_open(false)}
                                    sx={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        m:1,
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#80ed99',
                                            color:'#000'
                                        }, 
                                    }}
                                >
                                    Close
                                </Button>
                                <DataGrid
                                    rows={momo_deposits}
                                    columns={momo_columns}
                                    checkboxSelection
                                    getRowId={(row) => row.id}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: { 
                                                id: false,
                                                association_type: false,
                                                association_id: false
                                            },
                                        },
                                    }}
                                />
                            </CustomTabPanel>
                            <CustomTabPanel value={value2} index={1}>
                            <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', marginRight:'auto' }}>
                                    <b>Investors Bank/Momo Deposits</b>
                                </Typography>
                                <Button
                                    variant='contained'
                                    size='small'
                                    color='error'
                                    onClick={() => setMomo_open(false)}
                                    sx={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        m:1,
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#80ed99',
                                            color:'#000'
                                        }, 
                                    }}
                                >
                                    Close
                                </Button>
                                <DataGrid
                                    rows={investor_deposits}
                                    columns={columns_investment_banks}
                                    checkboxSelection
                                    getRowId={(row) => row.id}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: { 
                                                id: false
                                            },
                                        },
                                    }}
                                />
                            </CustomTabPanel>  
                            <CustomTabPanel value={value2} index={2}>
                                <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', marginRight:'auto' }}>
                                    <b>Society Warehouse Released Funds</b>
                                </Typography>
                                <DataGrid
                                    rows={main_ware_data}
                                    columns={columns_ware}
                                    checkboxSelection
                                    getRowId={(row) => row.transaction_id}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: { 
                                                transaction_id: false
                                            },
                                        },
                                    }}
                                />
                            </CustomTabPanel>  
                        </Grid>
                    </Grid>
              </Box>
            </Modal>
        </Grid>

        
    )
}

export default MainAccounts;